// @flow
import React, { useContext } from 'react';
import { useFormikContext } from 'formik';
import { useParams } from 'react-router-dom';
import {
  useDisableTableFlowWorkloadMutation,
  useEnableTableFlowWorkloadMutation,
} from '@streaming-projects/service-definitions/streamingProjectsApi';
import { CheckBoxField } from '@src/formik-utils/FormFields';
import { toastError } from '@presentational/notifications/utils';
import { SPStreamingProjectContext } from '@streaming-projects/sp-page/contexts/SPStreamingProjectContext';
import { TABLEFLOW_WORKLOADS_INPUTS_FIELDNAMES } from '@streaming-projects/orgs/enums';

import { TABLEFLOW_WORKLOAD_DETAILS_CONFIG_MAP } from '../config';

export const SPTableFlowWorkloadEnabledContainer = ({
  tableFlowWorkloadId = null,
  tableFlowResourceId = null,
  checked = null,
  addLabel = true,
}) => {
  const { orgId, spId } = useParams();
  const { isValid } = useFormikContext();
  const spStreamingProjectData = useContext(SPStreamingProjectContext);

  const [enableTableFlowWorkload] = useEnableTableFlowWorkloadMutation();
  const [disableTableFlowWorkload] = useDisableTableFlowWorkloadMutation();

  const { backendFieldName, displayName, icon } = TABLEFLOW_WORKLOAD_DETAILS_CONFIG_MAP.get(
    TABLEFLOW_WORKLOADS_INPUTS_FIELDNAMES.IS_ENABLED
  );

  const checkedProps = checked != null ? { checked } : {};
  return (
    <CheckBoxField
      addLabel={addLabel}
      disabled={!isValid}
      fieldDisplayName={displayName}
      fieldName={backendFieldName}
      icon={icon}
      onChange={async (event, value, setFieldValue, setFieldTouched, values, checked) => {
        const payload = {
          tableflow_resource_id: tableFlowResourceId,
          sp_version: spStreamingProjectData?.sp?.version,
        };

        const funcToCall = checked ? enableTableFlowWorkload : disableTableFlowWorkload;

        const { error } = await funcToCall({
          orgId,
          spId,
          tableFlowWorkloadId,
          payload,
        });

        if (error) {
          toastError(error);
        }
      }}
      {...checkedProps}
    />
  );
};
